$(function() {
  $('.related-briefing-item').on('click', function() {
    var $this = $(this);
    ahoy.track('Clicked related briefing content', {
      page: window.location.pathname,
      briefing_id: $this.data('briefing-id'),
      related_class: $this.data('related-class'),
      related_id: $this.data('related-id'),
      related_slug: $this.data('related-slug'),
      user_id: currentUser.id
    });
  });
});
